import type { EntityType, FlatContentLayersType } from "@config";

export const getWholeEntityLayers = (
  id: string,
  flatContentLayers: FlatContentLayersType,
) => {
  const entities = {} as Record<string, EntityType>;
  const entity = flatContentLayers[id];
  if (!entity) return;
  const handleChildEntities = (entity: EntityType) => {
    entities[entity.id] = entity;
    entity.childIds.forEach((id) => {
      const childEntity = flatContentLayers[id];
      if (!childEntity) return;
      handleChildEntities(childEntity);
    });
  };

  handleChildEntities(entity);
  return { root: id, entities };
};
